import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

Vue.use(Vuex);

const state = {
  userInfo: {},
  orgTree: {},
  unreadMessageInfo: {}
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});



// WEBPACK FOOTER //
// ./src/store/index.js